module.exports = __webpack_public_path__ + "static/media/you_glasses 4.75b366b0.png";